import React from "react";
import styles from "./VenueItem.module.scss";
import {IVenue} from "../../models/Venue";
import {getVenueImage} from "../../helpers/image.helper";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import arrowRight from "../../assets/images/icons/arrow-right-3.svg";
import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";
import {openLoginPopup} from "../../store/notification/notificationSlice";
import {textCropping} from "../../helpers/language.helper";


interface VenueItemProps {
    venue: IVenue
}

const VenueItem: React.FC<VenueItemProps> = ({venue}) => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const {isAuthorized} = useAppSelector(state => state.profileSlice);
    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    const handleLink = () => {
        if (!isAuthorized) {
            dispatch(openLoginPopup({isOpen: true}));
        }
    }

    return (
        <div className={styles.item} style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, venue.image)})`}}>
            <div className={styles.content}>
                <h3 className={styles.title}>{venue.name}</h3>
                <p className={styles.description}>{textCropping(venue.description, 560) }</p>
                <Link
                    onClick={handleLink}
                    to={`${isAuthorized ? "/venues/" + venue.id : "/venues"}`}
                    className={styles.link}
                >
                    {t("SeeDetails")}
                    <img className={styles.icon} src={arrowRight} alt={"arrow right"}/>
                </Link>
            </div>
        </div>
    )
}

export default VenueItem;